import type { Penalty } from "@daytrip/legacy-models";

import { ModelOperator } from "./ModelOperator";
import type { ModelOperatorOptions } from "./ModelOperatorOptions";

interface PenaltyOperatorOptions extends ModelOperatorOptions<Penalty, {}, {}> {}

export class PenaltyOperator extends ModelOperator<Penalty, PenaltyOperatorOptions, {}, {}, {}> {}
